import { compose } from 'recompose'
import { connect } from 'react-redux'
import {
  selectCustomerDisclaimer,
  selectCorporateProfile
} from 'src/store/selectors/customerProfile'
import { toggleDisclaimer } from 'src/actions/layout'

const DisclaimerModalContainer = compose(
  connect(
    state => {
      const corp = selectCorporateProfile(state) || {}

      return {
        equalHousingType: corp.equalHousingType,
        custDisclaimer: selectCustomerDisclaimer(state),
        corpDisclaimer: corp.disclaimer
      }
    },
    dispatch => ({
      toggle: () => dispatch(toggleDisclaimer())
    })
  )
)

export default DisclaimerModalContainer
